module.exports = __webpack_public_path__ + "img/lb.c65f4620.png";